<div
  class="tw-flex tw-min-w-0 tw-flex-col md:tw-flex-row tw-border tw-border-gray-200 tw-rounded-lg tw-gap-3 tw-p-3 md:tw-items-center tw-font-inter"
  >
  <div class="tw-flex tw-flex-row tw-justify-between tw-min-w-0 md:tw-flex-1">
    <div
    class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-row tw-gap-1 tw-overflow-hidden md:tw-gap-2"
    [ngClass]="{ 'tw-items-center': !hasFullname(), 'tw-opacity-40': statusLabel() === 'Suspended' }"
  >
      @if (hasProfilePicture()) {
        <img [src]="avatarSrc()" [alt]="user().fullname" class="tw-w-8 tw-h-8 tw-rounded-full tw-object-cover tw-shrink-0"/>
      } @else {
        <div
          class="tw-flex tw-w-8 tw-h-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-200 tw-text-xs tw-font-medium tw-text-gray-600"
        >
          {{ avatarInitials() }}
        </div>
      }
      <div
        class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-overflow-hidden"
        [ngClass]="{ 'tw-justify-center': !hasFullname() }"
      >
        @if (hasFullname()) {
          <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-1">
            <p
              #fullnameTruncation="appTruncationDetector"
              appTruncationDetector
              class="tw-min-w-0 tw-truncate tw-text-xs tw-font-bold tw-text-gray-900"
              [ngxTippy]="fullnameTruncation.isTruncated() ? user().fullname : null"
              [tippyProps]="{ theme: 'dark' }"
            >
              {{ user().fullname }}
            </p>
            @if (isCurrentUser()) {
              <span
                class="tw-inline-flex tw-shrink-0  tw-px-1.5 tw-py-0.5 tw-text-gray-900 tw-text-xs tw-font-semibold tw-leading-none"
              >
                (You)
              </span>
            }
          </div>
        }
        <p
          #emailTruncation="appTruncationDetector"
          appTruncationDetector
          class="tw-w-full tw-truncate tw-text-xs tw-text-gray-500"
          [ngxTippy]="emailTruncation.isTruncated() ? user().email : null"
          [tippyProps]="{ theme: 'dark' }"
        >
          {{ user().email }}
        </p>
      </div>
    </div>
    <div class="tw-flex tw-shrink-0 tw-flex-col tw-items-end md:tw-hidden">
      <p class="tw-text-xs tw-text-gray-500">Last seen:</p>
      <p class="tw-text-xs tw-text-gray-500">{{ lastSeen() }}</p>
    </div>
  </div>
  <div class="tw-flex tw-flex-row tw-gap-2 md:tw-contents">
    @if (shouldShowRoleDropdown()) {
      <app-dropdown
        class="tw-flex tw-flex-1 md:tw-flex-none md:tw-shrink-0"
        [id]="'user-role-' + user().id"
        [dropdownOptions]="roleDropdownOptions()"
        [disableDropdown]="isRoleDropdownDisabled()"
        [widthInPX]="'170px'"
        [heightInPX]="146"
        (optionClicked)="onRoleOptionClicked($event)"
      >
        <button
          type="button"
          class="tw-h-7 lg:tw-h-auto tw-flex tw-flex-1 tw-items-center tw-justify-center tw-gap-1 tw-px-2.5 tw-py-0.5 tw-border tw-rounded tw-border-gray-200 tw-bg-gray-50 tw-text-gray-900 tw-text-inter tw-font-medium tw-text-xs md:tw-w-[118px] md:tw-flex-none md:tw-shrink-0"
        >
          <span class="tw-inline-flex tw-shrink-0" [innerHTML]="roleIcon() | safe" aria-hidden="true"></span>
          {{ user().role | titlecase }}
          @if (showRoleDropdownChevron()) {
            <svg
              class="tw-shrink-0"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          }
        </button>
      </app-dropdown>
    } @else {
      <button
        type="button"
        disabled
        class="tw-h-7 lg:tw-h-auto tw-flex tw-flex-1 md:tw-flex-none md:tw-shrink-0 tw-items-center tw-justify-center tw-gap-1 tw-px-2.5 tw-py-0.5 tw-border tw-rounded tw-border-gray-200 tw-bg-gray-50 tw-text-gray-900 tw-text-inter tw-font-medium tw-text-xs md:tw-w-[118px] tw-opacity-100"
      >
        <span class="tw-inline-flex tw-shrink-0" [innerHTML]="roleIcon() | safe" aria-hidden="true"></span>
        {{ user().role | titlecase }}
      </button>
    }
    <app-dropdown
      class="tw-flex tw-flex-1 md:tw-flex-none md:tw-shrink-0"
      [id]="'user-status-' + user().id"
      [dropdownOptions]="statusDropdownOptions()"
      [disableDropdown]="isStatusDropdownDisabled()"
      [widthInPX]="'190px'"
      [heightInPX]="98"
      (optionClicked)="onStatusOptionClicked($event)"
    >
      <button
        type="button"
        class="tw-h-7 lg:tw-h-auto tw-flex tw-w-full md:tw-w-[97px] tw-items-center tw-justify-center tw-gap-1 tw-px-2.5 tw-py-0.5 tw-border tw-rounded tw-text-inter tw-font-medium tw-text-xs"
        [ngClass]="statusClasses()"
      >
        {{ statusLabel() }}
        @if (showStatusDropdownChevron()) {
          <svg
            class="tw-shrink-0"
            [ngClass]="statusTextColorClass()"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path d="M2.5 3.75L5 6.25L7.5 3.75" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        }
      </button>
    </app-dropdown>
  </div>
  <p class="tw-text-xs tw-text-gray-500 tw-hidden md:tw-block md:tw-w-[82px] md:tw-shrink-0  md:tw-text-end">{{ lastSeen() }}</p>
</div>
